<template>
  <button
    @click.stop="close"
    type="button"
    :class="{ 'mobile-close': rootStore.isMobile }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
    >
      <g
        fill="currentColor"
        :style="{ fill: color }"
        fill-rule="evenodd"
        transform="rotate(-90 5.75 5.396)"
      >
        <path
          d="M5.64644661,-1.35355339 C5.92258898,-1.35355339 6.14644661,-1.12969577 6.14644661,-0.853553391 L6.14644661,11.1464466 C6.14644661,11.422589 5.92258898,11.6464466 5.64644661,11.6464466 C5.37030423,11.6464466 5.14644661,11.422589 5.14644661,11.1464466 L5.14644661,-0.853553391 C5.14644661,-1.12969577 5.37030423,-1.35355339 5.64644661,-1.35355339 Z"
          transform="rotate(45 5.646 5.146)"
        />
        <path
          d="M5.64644661,-1.35355339 C5.92258898,-1.35355339 6.14644661,-1.12969577 6.14644661,-0.853553391 L6.14644661,11.1464466 C6.14644661,11.422589 5.92258898,11.6464466 5.64644661,11.6464466 C5.37030423,11.6464466 5.14644661,11.422589 5.14644661,11.1464466 L5.14644661,-0.853553391 C5.14644661,-1.12969577 5.37030423,-1.35355339 5.64644661,-1.35355339 Z"
          transform="rotate(-45 5.646 5.146)"
        />
      </g>
    </svg>
    <!--     <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
    >
      <path
        fill="currentColor"
        :style="{ fill: color }"
        d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
      ></path>
    </svg> -->
  </button>
</template>

<script>
export default {
  props: ['color'],
  methods: {
    close() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  background: transparent;
  border: none;
  width: 12px;
  height: 12px;
  padding: 0;

  &.mobile-close {
    transform: scale(1.2);
  }
}
svg {
  width: 12px;
  height: 12px;
  cursor: pointer;

  path {
    fill: var(--sub-color);
  }
}
</style>
